/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hc_Domains_Step_2Inputs */

const en_hc_domains_step_2 = /** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your own domain (BYOD). Already own a domain? Enter it in the dashboard. We'll provide two DNS records (A and CNAME) for your hosting and two TXT records (SPF/DKIM) for your white-label email.`)
};

const es_hc_domains_step_2 = /** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta tu propio dominio (BYOD). ¿Ya tienes uno? Introdúcelo en el panel. Te proporcionaremos dos registros DNS (A y CNAME) para el alojamiento y dos registros TXT (SPF/DKIM) para tu correo de marca blanca.`)
};

const fr_hc_domains_step_2 = /** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez votre propre domaine (BYOD). Vous possédez déjà un domaine ? Entrez-le dans le tableau de bord. Nous vous fournirons deux enregistrements DNS (A et CNAME) pour votre hébergement et deux enregistrements TXT (SPF/DKIM) pour vos e-mails en marque blanche.`)
};

const de_hc_domains_step_2 = /** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde deine eigene Domain (BYOD). Besitzt du bereits eine Domain? Gib sie im Dashboard ein. Wir stellen dir zwei DNS-Einträge (A und CNAME) für dein Hosting und zwei TXT-Einträge (SPF/DKIM) für deine Whitelabel-E-Mails zur Verfügung.`)
};

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const ja_hc_domains_step_2 = en_hc_domains_step_2;

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const zh_hc_domains_step_2 = en_hc_domains_step_2;

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const ar_hc_domains_step_2 = en_hc_domains_step_2;

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const id_hc_domains_step_2 = en_hc_domains_step_2;

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const it_hc_domains_step_2 = en_hc_domains_step_2;

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const ru_hc_domains_step_2 = en_hc_domains_step_2;

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const pt_hc_domains_step_2 = en_hc_domains_step_2;

/** @type {(inputs: Hc_Domains_Step_2Inputs) => LocalizedString} */
const ko_hc_domains_step_2 = en_hc_domains_step_2;

/**
* | output |
* | --- |
* | "Connect your own domain (BYOD). Already own a domain? Enter it in the dashboard. We'll provide two DNS records (A and CNAME) for your hosting and two TXT rec..." |
*
* @param {Hc_Domains_Step_2Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hc_domains_step_2 = /** @type {((inputs?: Hc_Domains_Step_2Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hc_Domains_Step_2Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hc_domains_step_2(inputs)
	if (locale === "es") return es_hc_domains_step_2(inputs)
	if (locale === "fr") return fr_hc_domains_step_2(inputs)
	if (locale === "de") return de_hc_domains_step_2(inputs)
	if (locale === "ja") return ja_hc_domains_step_2(inputs)
	if (locale === "zh") return zh_hc_domains_step_2(inputs)
	if (locale === "ar") return ar_hc_domains_step_2(inputs)
	if (locale === "id") return id_hc_domains_step_2(inputs)
	if (locale === "it") return it_hc_domains_step_2(inputs)
	if (locale === "ru") return ru_hc_domains_step_2(inputs)
	if (locale === "pt") return pt_hc_domains_step_2(inputs)
	return ko_hc_domains_step_2(inputs)
});